module.exports = __webpack_public_path__ + "media/native-apps/haninge-839a425f.webp";